// AI-CONTEXT: See docs/pitfalls.md#api-callable-timestamp-vs-ms
//
// One date value reaches a live-report widget in three different shapes:
//   - a Firestore Timestamp        (read straight from a collection)
//   - a plain local Date           (the period context; see useWidgetPeriod)
//   - a serialized { _seconds }    (the public viewer's JSON from the Cloud Function)
//
// Calling `.toDate()` on the second one throws, and inside a render that takes
// the whole public page down with an uncaught error — which is exactly what
// happened to the Onderzoek widget in a report that had a period set.

const DISPLAY_OPTIONS = { day: 'numeric', month: 'short', year: 'numeric' };

/**
 * Format any of the date shapes a live-report widget can receive.
 *
 * @param {*} value - Firestore Timestamp, Date, `{_seconds}`/`{seconds}`, or a parseable string
 * @returns {string} A readable date, or '' when there is nothing to show —
 *   never 'Invalid Date', which reads to a user as a broken report.
 */
const toDisplayDate = (value) => {
    if (!value) return '';

    let date;
    if (typeof value.toDate === 'function') {
        date = value.toDate();
    } else if (value instanceof Date) {
        date = value;
    } else if (typeof value._seconds === 'number') {
        date = new Date(value._seconds * 1000);
    } else if (typeof value.seconds === 'number') {
        date = new Date(value.seconds * 1000);
    } else if (typeof value === 'string' || typeof value === 'number') {
        date = new Date(value);
    } else {
        return '';
    }

    return isNaN(date.getTime()) ? '' : date.toLocaleDateString(undefined, DISPLAY_OPTIONS);
};

export default toDisplayDate;
